// useCommentaires.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import CommentaireService from "@/integrations/service/commentaire.service";

export const useCommentaires = (articleId?: number) => {
  return useQuery({
    queryKey: queryKeys.commentaires(articleId ?? 0),
    queryFn: () => CommentaireService.getByArticle(articleId as number),
    enabled: !!articleId,
  });
};

export const useCreateCommentaire = (articleId?: number) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: CommentaireService.create,
    onSuccess: () => {
      if (articleId) qc.invalidateQueries({ queryKey: queryKeys.commentaires(articleId) });
    },
  });
};

/** Modération admin — retourne les commentaires de tous statuts. */
export const useCommentairesAdmin = (articleId?: number) => {
  return useQuery({
    queryKey: [...queryKeys.commentaires(articleId ?? 0), "admin"],
    queryFn: () => CommentaireService.getAllByArticle(articleId as number),
    enabled: !!articleId,
  });
};

export const useChangerStatutCommentaire = (articleId?: number) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, statut }: { id: number; statut: "EN_ATTENTE" | "APPROUVE" | "REJETE" }) =>
      CommentaireService.changerStatut(id, statut),
    onSuccess: () => {
      if (articleId) {
        qc.invalidateQueries({ queryKey: queryKeys.commentaires(articleId) });
        qc.invalidateQueries({ queryKey: [...queryKeys.commentaires(articleId), "admin"] });
      }
    },
  });
};

export const useDeleteCommentaire = (articleId?: number) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: CommentaireService.delete,
    onSuccess: () => {
      if (articleId) {
        qc.invalidateQueries({ queryKey: queryKeys.commentaires(articleId) });
        qc.invalidateQueries({ queryKey: [...queryKeys.commentaires(articleId), "admin"] });
      }
    },
  });
};
